import { useState } from 'react';
import { AuthProvider, useAuth } from './hooks/useAuth';
import AuthPage from './pages/AuthPage';
import EditorPage from './pages/EditorPage';
import HomePage from './pages/HomePage';

function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg,#f8fafc,#eff6ff)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Sora',sans-serif",
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 64, height: 64,
          background: 'linear-gradient(135deg,#3b82f6,#6366f1)',
          borderRadius: 16,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 32, margin: '0 auto 20px',
          boxShadow: '0 8px 32px rgba(59,130,246,0.3)',
        }}>
          📄
        </div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', marginBottom: 8 }}>
          FreePDFMaster.in
        </div>
        <div style={{ fontSize: 13, color: '#94a3b8' }}>Loading your workspace…</div>
        <div style={{
          width: 48, height: 3,
          background: 'linear-gradient(135deg,#3b82f6,#6366f1)',
          borderRadius: 2, margin: '20px auto 0',
          animation: 'pulse 1.5s ease-in-out infinite',
        }} />
      </div>
    </div>
  );
}

function AppContent() {
  const { user, loading } = useAuth();
  // null = home, string = specific tool hint (opens editor)
  const [selectedTool, setSelectedTool] = useState(null);

  if (loading) return <LoadingScreen />;
  if (!user) return <AuthPage />;

  if (selectedTool !== null) {
    return (
      <EditorPage
        toolHint={selectedTool}
        onBack={() => setSelectedTool(null)}
      />
    );
  }

  return <HomePage onSelectTool={setSelectedTool} />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
